import React, { useMemo, memo, useRef, useState, useEffect } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useSelector } from 'react-redux';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { useTranslation } from 'react-i18next';

import NoChartsData from '../../no-charts-data/NoChartsData';
import { createOptions } from './StackedHorizontalBarsUtils';
import StackedHorizontalBarsLabels from './StackedHorizontalBarsLabels';

import scss from './StackedHorizontalBars.module.scss';

ChartJS.register(CategoryScale, LinearScale, BarElement, ChartDataLabels, Tooltip, Legend);

const StackedHorizontalBars = ({ data, config, labels }) => {
  const chartRef = useRef(null);
  const theme = useSelector((state) => state.global.theme);
  const [height, setHeight] = useState('500px');
  const { t } = useTranslation();

  const options = useMemo(() => {
    return createOptions({ theme, config, data });
  }, [theme, config, data]);

  useEffect(() => {
    if (data) {
      setHeight(data.datasets[0].data.length * 40 + 32 + 30 + 'px');
    }
  }, [data]);

  //fix tooltip on unmount
  useEffect(() => {
    return () => {
      const tooltip = document.getElementById('chartJsStackedHorizontalBars');
      if (tooltip) {
        tooltip.remove();
      }
    };
  }, []);

  if (!data?.datasets?.[0]?.data?.length) {
    return <NoChartsData height={height} noDataText={t('noData')} />;
  }

  return (
    <div style={{ height, display: 'flex' }}>
      <StackedHorizontalBarsLabels labels={labels} />
      <Bar ref={chartRef} options={options} data={data} className={scss.barChart} />
    </div>
  );
};

export default memo(StackedHorizontalBars);
